webpackJsonp([93449047059328],{

/***/ 470:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"frontmatter":{"title":"Pricing","meta_title":"Pricing | Spin Auto","meta_description":"$9.99 for a lease","pricing":{"heading":"What's the cost?","description":"Nothing in the world is free.  Even so, how can you be giving leases away so cheaply!?!","plans":[{"description":"Looking for something with four wheels, looks nice and goes fast?  Start here!","items":["Sedans","Coupes","Luxury Vehicles"],"plan":"Town Car","price":"9.99"},{"description":"Be the envy of Soccer practices.  Drive vehicles what will help to keep your family safe!","items":["SUV's","Mini-Vans"],"plan":"Family Car","price":"??"},{"description":"Need a vehicle to load work materials?  Or something special for a special someone? Start here!","items":["Pick-up trucks","Handicap Accessible Vehicles."],"plan":"Utitily Vehicle","price":"??"}]}}}},"pathContext":{"id":"/opt/build/repo/src/pages/pricing/index.md absPath of file >>> MarkdownRemark"}}

/***/ })

});


// WEBPACK FOOTER //
// path---pricing-57f52e2ae5457ba0184e.js